import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-layout-session',
    templateUrl: './layout-session.component.html',
    standalone: false
})
export class LayoutSessionComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
